import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Card,
  Popper,
  CardHeader,
  Divider,
  CardContent,
  Grid,
  TextField,
  Box,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import genService from 'src/services/generalServices';
import { es as esLocale } from 'date-fns/locale/es';

const useStyles = makeStyles((theme) => ({
  root: {},
  bottomSpace: {
    marginBottom: theme.spacing(1)
  },
}));

const BusquedaClientes = ({
  openPopper,
  anchorEl,
  setFechaDesde,
  setFechaHasta,
  fechaDesde,
  fechaHasta,
  comboTipoClientes,
  onSubmitAdv
}) => {
  const { register, handleSubmit, control } = useForm();
  const classes = useStyles();
  const [openFechaHasta, setOpenFechaHasta] = React.useState(false);
  const [openFechaDesde, setOpenFechaDesde] = React.useState(false);

  return (
    <Popper
      open={openPopper}
      anchorEl={anchorEl}
      modifiers={[{ name: 'computeStyles', options: { gpuAcceleration: false } }]}
    >
      <form onSubmit={handleSubmit((data) => onSubmitAdv(data, 'adv'))}>
        <Card className={classes.root}>
          <CardHeader
            avatar={<Search fontSize="small" color="primary" />}
            subheader="Búsqueda avanzada"
            style={{ padding: '5px' }}
          />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Cliente"
                  size="small"
                  {...register('nombreCliente')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="RFC"
                  size="small"
                  {...register('rfc')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <DatePicker
                    open={openFechaDesde}
                    onOpen={() => setOpenFechaDesde(true)}
                    onClose={() => setOpenFechaDesde(false)}
                    onChange={setFechaDesde}
                    format="dd/MM/yyyy"
                    label="Desde"
                    value={fechaDesde}
                    slotProps={{
                      textField: {
                        name: 'desde',
                        margin: 'normal'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <DatePicker
                    open={openFechaHasta}
                    onOpen={() => setOpenFechaHasta(true)}
                    onClose={() => setOpenFechaHasta(false)}
                    onChange={setFechaHasta}
                    format="dd/MM/yyyy"
                    label="Hasta"
                    value={fechaHasta}
                    slotProps={{
                      textField: {
                        name: 'hasta',
                        margin: 'normal'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Contacto"
                  size="small"
                  {...register('contacto')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <FormControl variant="outlined" size="small" className={classes.formControl} fullWidth>
                  <InputLabel htmlFor="tipoCliente-select">
                    <div>Tipo de Cliente</div>
                  </InputLabel>
                  <Controller
                    control={control}
                    name="tipoCliente"
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        {...field}
                        id="tipoCliente-select"
                        label="Tipo de Cliente"
                        MenuProps={{
                          disablePortal: true,
                          PaperProps: { style: { position: 'sticky' } }
                        }}
                      >
                        <MenuItem>Seleccione un valor</MenuItem>
                        {comboTipoClientes.map((itemCliente) => (
                          <MenuItem
                            key={itemCliente.value}
                            value={itemCliente.value}
                          >
                            {itemCliente.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <div className={classes.bottomSpace} />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                type="submit"
              >
                Buscar
              </Button>
            </Box>
          </CardContent>
        </Card>
      </form>
    </Popper>
  );
};

BusquedaClientes.propTypes = {
  anchorEl: PropTypes.object,
  openPopper: PropTypes.bool,
  setFechaDesde: PropTypes.func,
  setFechaHasta: PropTypes.func,
  fechaDesde: PropTypes.string,
  fechaHasta: PropTypes.string,
  onSubmitAdv: PropTypes.func,
  comboTipoClientes: PropTypes.array
};
export default BusquedaClientes;
